import PlayerInfoCard from './PlayerInfoCard.svelte';

!customElements.get('player-info-card') && customElements.define('player-info-card', PlayerInfoCard);
export default PlayerInfoCard;
